
document.addEventListener('DOMContentLoaded', () => {
    function setupForm() {
        const form = document.getElementById('product-register-form');
        const requiredFields = [
            { id: '122784-text', name: 'FirstName' },
            { id: '122784-text-2', name: 'LastName' },
            { id: '122784-email', name: 'Email Address' },
            { id: '122784-text-9', name: 'Model Number' },
            { id: '122784-datetime', name: 'Date Purchased' }
        ];
        
        const checkbox = document.querySelector('.checkbox-wrapper input[type="checkbox"]');
        const requiredMessage = document.getElementById('required-message-fields');
        const errorMessageElement = document.getElementById('error-message');
        const successDiv = document.getElementById('right14112'); // The div to add the class to

        function validateRequiredFields() {
            let isValid = true;
            let errorMessage = '';

            requiredFields.forEach(field => {
                const input = document.getElementById(field.id);
                if (!input.value.trim()) {
                    isValid = false;
                    input.style.setProperty('border', '2px solid red', 'important');
                } else {
                    input.style.setProperty('border', '2px solid #EFEFEF', 'important');
                }
            });

            // if (!checkbox.checked) {
            //     isValid = false;
            //     checkbox.nextElementSibling.style.color = 'red';
            //     checkbox.style.setProperty('outline', '2px solid red', 'important');
            // } else {
            //     checkbox.nextElementSibling.style.color = '';
            //     checkbox.style.setProperty('outline', '', 'important');
            // }

            if (!isValid) {
                errorMessage = 'Please fill in the required fields.';
                requiredMessage.textContent = errorMessage;
                requiredMessage.style.display = 'block';
            } else {
                requiredMessage.style.display = 'none';
            }
            
            return isValid;
        }

        form.addEventListener('submit', function(event) {
            event.preventDefault();

            if (!validateRequiredFields()) {
                return; // Stop if validation fails
            }

            const firstname = document.getElementById('122784-text').value.trim();
            const lastname = document.getElementById('122784-text-2').value.trim();
            const address = document.getElementById('122784-text-3') ? document.getElementById('122784-text-3').value.trim() : '';
            const city = document.getElementById('122784-text-5') ? document.getElementById('122784-text-5').value.trim() : '';
            const state = document.getElementById('122784-text-6') ? document.getElementById('122784-text-6').value.trim() : '';
            const postalZipCode = document.getElementById('122784-text-7') ? document.getElementById('122784-text-7').value.trim() : '';
            const email = document.getElementById('122784-email').value.trim();
            const phoneNumber = document.getElementById('phone-number') ? document.getElementById('phone-number').value.trim() : '';
            const country = document.getElementById('122784-select') ? document.getElementById('122784-select').value.trim() : '';
            const modelNumber = document.getElementById('122784-text-9').value.trim();
            const purchaseDate = document.getElementById('122784-datetime').value.trim();

            const phonePattern = /^\d{1,12}$/; // Validate phone number with up to 12 digits
            if (phoneNumber && !phonePattern.test(phoneNumber)) {
                errorMessageElement.textContent = 'Phone number must contain only numbers and be up to 12 digits long.';
                return;
            }

            const checkboxes = document.getElementsByClassName('checkbox-input');
            let checkboxValue = '';
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    checkboxValue = checkboxes[i].value;
                    break;
                }
            }

            const data = {
                FirstName: firstname,
                LastName: lastname,
                Address: address,
                City: city,
                State: state,
                PostalZipCode: postalZipCode,
                Email: email,
                PhoneNumber: phoneNumber,
                Country: country,
                ModelNumber: modelNumber,
                PurchaseDate: purchaseDate,
                CheckboxValue: checkboxValue
            };

            const queryString = new URLSearchParams(data).toString();

            const xhr = new XMLHttpRequest();
            xhr.open("POST", "/apps/ac/product-registration.php", true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText);
                            console.log(response);

                            if (response.error) {
                                errorMessageElement.textContent = response.error;
                                errorMessageElement.style.display = 'block';
                            } else if (response.success) {
                                // Replace the form with a success message
                                form.innerHTML = `
                                    <div id="p-r form-sucess-message" class="form__message" style="color: green; margin-top: 15px; font-size:12px;">
                                        Thanks for registering!
                                    </div>
                                `;
                                
                                // Clear any previous error messages
                                errorMessageElement.textContent = '';
                                errorMessageElement.style.display = 'none';
                                
                                // Add the .submitted class to the div with ID right14112
                                if (successDiv) {
                                    successDiv.classList.add('submitted');
                                }
                            }
                        } catch (error) {
                            console.error("Failed to parse JSON response:", error);
                            errorMessageElement.textContent = 'An unexpected error occurred.';
                            errorMessageElement.style.display = 'block';
                        }
                    } else {
                        console.error("Server request failed with status:", xhr.status);
                        errorMessageElement.textContent = 'An unexpected error occurred.';
                        errorMessageElement.style.display = 'block';
                    }
                }
            };

            xhr.send(queryString);
        });

        requiredFields.forEach(field => {
            const input = document.getElementById(field.id);
            input.addEventListener('focus', () => {
                input.style.setProperty('border', '2px solid #EFEFEF', 'important');
            });
        });

        if (checkbox) {
            checkbox.addEventListener('focus', () => {
                checkbox.style.setProperty('outline', '', 'important');
            });
        }
    }

    window.addEventListener('load', setupForm);
});
/* Show  State based on country */
